export default __webpack_public_path__ + "media/images/open-graph-image-de5911633a6cd593b4828d40a5a702be.jpg";